module.exports = __webpack_public_path__ + "static/write2congressAndroidG-b759d1f7e9f4941a8884b5ec993d3101.gif";